import { FormControl } from "@angular/forms";
import { testCAEPF } from "@core/config/caepf-validador-config";

export function cnpjCaepfValidator(control: FormControl) {
    var reCNPJ = new RegExp(/[A-Za-z0-9]{2}\.?[A-Za-z0-9]{3}\.?[A-Za-z0-9]{3}\/?[A-Za-z0-9]{4}-?\d{2}/g);
    var reCAEPF = new RegExp(/[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{3}\-?[0-9]{2}/g);

    if (control.value != undefined && control.value != null && control.value != '') {

        let numbers = control.value.match(/\d/g);
        let numberLength = 0;

        let result = testCAEPF(control.value);

        if (numbers) {
            numberLength = numbers.join("").length;
        }
        if (!result && !reCNPJ.test(control.value)) {
            return {
                cnpjCaepf: true
            }
        }
    }
    return null;
    
}

